<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M4 15V3C4 3 5.5 2 8 2C10.5 2 12.5 4 15 4C17.5 4 19 3 19 3V15C19 15 17.5 16 15 16C12.5 16 10.5 14 8 14C5.5 14 4 15 4 15ZM4 15V22"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
